var React = require('react');

function Guides (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("defs",{"key":1},React.createElement("style",null,".cls-1{fill:#001b35}")),React.createElement("path",{"className":"cls-1","d":"M11.3 11.3a1 1 0 000 1.4 1 1 0 100-1.4z","key":2}),React.createElement("path",{"className":"cls-1","d":"M19.88 10.64a7.88 7.88 0 00-1.34-3.25 8 8 0 00-1.93-1.93 7.88 7.88 0 00-3.25-1.34 7.77 7.77 0 00-2.72 0 7.88 7.88 0 00-3.25 1.34 8 8 0 00-1.93 1.93 7.88 7.88 0 00-1.34 3.25 7.77 7.77 0 000 2.72 7.88 7.88 0 001.34 3.25 8 8 0 001.93 1.93 7.88 7.88 0 003.25 1.34 7.77 7.77 0 002.72 0 7.88 7.88 0 003.25-1.34 8 8 0 001.93-1.93 7.88 7.88 0 001.34-3.25 7.77 7.77 0 000-2.72zm-3.82-2.08l-2.27 4.83a.91.91 0 01-.4.4l-4.83 2.27a.47.47 0 01-.62-.62l2.27-4.83a1 1 0 01.4-.4l4.83-2.27a.47.47 0 01.62.62z","key":3})]);
}

Guides.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 24 24"};

module.exports = Guides;

Guides.default = Guides;
